if not App.angularApp?
    return

App.angularApp.directive 'mfPostRepeat', ['$document', '$timeout', ($document, $timeout) ->
    return {
        restrict: 'A'
        link: (scope, ele, attrs) ->
            # This directive ensures that we don't try to
            # update the map legend with inner HTML until angular has updated the view
            if scope.$last
                $timeout(() =>
                    scope.$emit(scope[attrs.mfPostRepeat])
                )

    }
]
